import { Pipe, PipeTransform } from '@angular/core';
import { TypeEntretien } from '../../models/typeEntretien';

@Pipe({
	name: 'filterTypeEntretienByName'
})
export class FilterTypeEntretienByNamePipe implements PipeTransform {
	transform(typeEntretien: TypeEntretien[], filter: string): TypeEntretien[] {
		if (
			!typeEntretien ||
			!filter ||
			typeEntretien === null ||
			filter === null ||
			filter === ''
		) {
			return typeEntretien;
		}

		return typeEntretien.filter((typeEntretien: TypeEntretien) => {
			if (typeEntretien.name) {
				// TODO: add lastName too
				return typeEntretien.name.toLowerCase().includes(filter.toLowerCase());
			}
			return false;
		});
	}
}
